export default __webpack_public_path__ + "static/media/cert-hr-consumer.782404f8.jpg";